import {EntityFactory, Reducer} from '@modifi/redux'
import {createSelector} from 'reselect'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'

type State = Record<string, any>
const client = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: `data/bank-utils`,
  rootSelector: state => state.data.bankUtils,
  fetchRequest: (state, params: {swiftCode: string}): Promise<any> =>
    client.BankUtils.fetchBankDetails(params).then(res => res.data()),
})

export default reducer as Reducer

const selectBankUtils = (state: State): any => selectors.selectEntity(state) || {}

export const aFetchBankUtils = (params: {swiftCode: string}): any => actions?.fetch(params)

export const aClearBankUtils = (): any => actions?.clear()

export const selectBankName = createSelector(selectBankUtils, bankUtils => bankUtils?.bankName)

export const selectBankUtilsErrorMessage = selectors.selectErrorMessage
